import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import Link from '@material-ui/core/Link';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
    },
    appBar: {
        backgroundColor: "white",
        boxShadow: "none",
        color: "inherit"
    }
}));

export default function Footer() {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Divider />
            <AppBar position="static" className={classes.appBar}>
                <Toolbar>
                    <Typography variant="body1" className={classes.title}>
                        Ibiso Barimalaa &copy; All right reserved {new Date().getFullYear()}
                        <Box mx={2} component="span" fontWeight="bold" style={{color: "wheat"}}>Built with 
                            <Box pl={1} target="_blank" component={Link} href="https://reactjs.org">React</Box>
                        </Box>
                    </Typography>
                </Toolbar>
            </AppBar>
        </div>
    );
}